import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { Panel } from "./fields";
import { Switch } from "../../components/ui/switch";

export const GoogleAdsPanel = () => {
  const { data } = useQuery({ queryKey: ["admin-google-ads"], queryFn: () => api.get("/admin/google-ads").then((r) => r.data) });
  const qc = useQueryClient();
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (data) setForm({ enabled: data.enabled, monthly_budget: data.monthly_budget, note: data.note });
  }, [data]);
  if (!form) return null;
  const save = async () => {
    if (Number(form.monthly_budget) < 0) return toast.error("The monthly budget cannot be negative");
    setBusy(true);
    try {
      qc.setQueryData(["admin-google-ads"], (await api.put("/admin/google-ads", { ...form, monthly_budget: Number(form.monthly_budget) || 0 })).data);
      toast.success("Google paid ads preference saved");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Panel title="Google paid hotel ads" hint="Free Google listings are set up by Hostech. Ask here for paid ads with a monthly budget; Hostech runs them from the Google Ads account and visits and bookings show above as 'Google paid ads'.">
      <p className="mb-4 text-sm text-ink/70" data-testid="google-ads-listed">
        Free Google listing: <b>{data.listed ? "On" : "Not switched on yet"}</b>
      </p>
      <label className="mb-4 flex items-center gap-3 text-sm">
        <Switch checked={form.enabled} onCheckedChange={(v) => setForm({ ...form, enabled: v })} data-testid="google-ads-enabled" />
        Run paid Google hotel ads for this site
      </label>
      {form.enabled && (
        <div className="grid gap-4 sm:grid-cols-2">
          <label className="field"><span className="field-label">Monthly budget ({data.currency})</span>
            <input type="number" min="0" className="field-input" value={form.monthly_budget} onChange={(e) => setForm({ ...form, monthly_budget: e.target.value.replace("-", "") })} data-testid="google-ads-budget" />
          </label>
          <label className="field"><span className="field-label">Notes for Hostech (optional)</span>
            <input className="field-input" maxLength={300} value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} data-testid="google-ads-note" />
          </label>
        </div>
      )}
      <button type="button" className="btn-primary mt-5" disabled={busy} onClick={save} data-testid="google-ads-save">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />}Save
      </button>
    </Panel>
  );
};
